import { defineMessages } from 'react-intl'

const messages = defineMessages({
  hotel: {
    id: 'global.hotel',
  },
  apartment: {
    id: 'global.apartment',
  },
  villa: {
    id: 'global.villa',
  },
  homes: {
    id: 'global.homes',
  },
  hostel: {
    id: 'global.hostel',
  },
  resort: {
    id: 'global.resort',
  },
  apthotel: {
    id: 'global.apthotel',
  },
})

export default messages
